import React, { useLayoutEffect } from 'react'
import BackButton from '../BackButton'
import SubmitButton from '../SubmitButton'
import Spacer from '../../../ui/atoms/Spacer'
import Layout from '../Layout'
import PasswordInput from '../PasswordInput'
import SignupStore from '../stores/SignupStore'
import { observer } from 'mobx-react'
import { paths } from '../../links'
import { PasswordHint } from '../PasswordHint'
import { useTranslation } from 'react-i18next'
import Title from '../Title'
import { AlreadyHaveAcc } from '../AlreadyHaveAcc'
import RootStore from '../../../store'

interface SignUpPasswordProps {
  navigation: any
  onContinue?: () => void
  dontNavigate?: (arg: boolean) => void
  onBack?: () => void
}

export default observer(
  ({ navigation, onContinue, dontNavigate, onBack }: SignUpPasswordProps) => {
    const {
      password,
      type,
      setPassword,
      canSubmit,
      isValidLogin,
      passwordValidation,
    } = SignupStore
    const { isBusy } = RootStore
    const { t } = useTranslation('auth')

    useLayoutEffect(() => {
      if (!(isValidLogin && type === 'password')) {
        navigation.replace(paths.Auth.SignUp)
      }
    }, [isValidLogin, navigation, type])

    const onBackPress = () => {
      if (onBack) onBack()
      else navigation.navigate(paths.Auth.SignUp)
    }

    return (
      <Layout onBackPress={onBackPress}>
        <BackButton onPress={onBackPress} testID="back-button" />
        <Title>{t('signUp.passwordTitle')}</Title>

        <Spacer />
        <PasswordInput
          testID="password"
          label={t('signUp.passwordLabel')}
          value={password}
          onChangeText={setPassword}
          newPassword
          showEye
          mandatory
          onSubmitEditing={undefined}
        />
        <Spacer />
        <PasswordHint
          passwordValidation={passwordValidation}
          testID="password-rules"
        />
        <Spacer height={39} />
        <SubmitButton
          onPress={() =>
            onContinue
              ? onContinue()
              : navigation.navigate(paths.Auth.SignUpForm)
          }
          disabled={!canSubmit || isBusy}
          testID="signup-button"
          loading={isBusy}
        >
          {t('signUp.submitLabel')}
        </SubmitButton>
        <Spacer height={40} />
        <AlreadyHaveAcc navigation={navigation} dontNavigate={dontNavigate} />
      </Layout>
    )
  },
)
